









































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { VersionLabel } from "@/components.nav/version-label";
import { productName, companyLogo } from "@/info";

export default defineComponent({

	emits:[],
	props:{
	},
	components:{
		VersionLabel,
	},
	setup(){
		
		return {
			productName,
			companyLogo,
		};
	}
});

